<template>
  <div>

    <div class="modal"  role="dialog">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Llene el siguiente formulario para envíar su solicitud.</h5>
            <button type="button" class="close"  aria-label="Close" @click="cerrar">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <fieldset class="fieldset">
                <legend>Solicitud / Consulta</legend>
                <div class="row form-group">
                    <label for="nombre" class="col-form-label col-sm-3">Nombre Completo</label>
                    <div class="col-sm-9"><input v-model="ticket.nombre" type="text" class="form-control"></div>
                </div>
                <div class="row form-group">
                    <label for="email" class="col-form-label col-sm-3">Correo electrónico</label>
                    <div class="col-sm-9"><input v-model="ticket.email" type="email" class="form-control"></div>
                </div>    
                <div class="row form-group">
                    <label for="telefono" class="col-form-label col-sm-3">Teléfono</label>
                    <div class="col-sm-9"><input v-model="ticket.telefono" type="number" class="form-control"></div>
                </div> 
                <div class="row form-group">
                    <label for="direccion" class="col-form-label col-sm-3">Dirección</label>
                    <div class="col-sm-9"><input v-model="ticket.direccion" type="text" class="form-control"></div>
                </div> 
                <div class="row form-group">
                    <label for="direccion" class="col-form-label col-sm-3">Describa brevemete su Consulta / Solicitud</label>
                    <div class="col-sm-9"><textarea v-model="ticket.consulta" class="form-control" name="" id="" cols="30" rows="10"></textarea></div>
                </div> 
            </fieldset>
         <div class="footer">
            <div class="row mt-3">
                <div class="col-sm-2 offset-sm-8"><button class="btn btn-primary btn-block">Envíar</button></div>
                <div class="col-sm-2"><button class="btn btn-danger btn-block" @click="cerrar">Cancelar</button></div>
            </div>
        </div>            
        </div>

        </div>
    </div>
        </div>               
  </div>
</template>

<script>
export default {
    data(){
        return{
            ticket:{
                nombre:null,
                email:null,
                telefono:null,
                direccion:null,
                consulta:null,       
            }
        }
    },
    methods:{
        cerrar(){
            this.$emit('close')
        }
    }

}
</script>

<style lang="scss" scoped>
  .modal {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;

    @media (min-width: 992px) {
      .modal-lg {
        width: 900px;
      }
    }

  }

	.bpb-background {
		width: 100%;
		height: 100%;
		background-color: #4C4C4C;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
	}

	.fieldset {
        padding-left: 15px;
        padding-right: 15px;
        margin-left: auto;
        margin-right: auto;
        border-width: 2px;
        border-style: groove;
        border-radius: 3px;

        legend {
            width: auto;
            margin-left: 10px;
            padding: 3px 10px;
        }  
	}    
</style>